import Vue from "vue";
import Vuex from "vuex";

import {
  statistic,
  STATISTIC_NAMESPACE,
  feedback,
  FEEDBACK_NAMESPACE,
} from "./modules";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userID: process.env.VUE_APP_USER_ID || null,
    sessionKey: process.env.VUE_APP_SESSION_ID || null,
    lat: process.env.VUE_APP_LAT || null,
    long: process.env.VUE_APP_LON || null,
    agreedTerms: false,
    silmeeByWeek: null,
    walkxByWeek: null,
    responseDataForMonthMode: null,
    responseDataForGroupMode: null,
  },
  mutations: {
    storeSessionKeyAndUserID(state, { userID, sessionKey }) {
      state.userID = userID;
      state.sessionKey = sessionKey;
    },
    storeLatAndLong(state, { lat, long }) {
      state.lat = lat;
      state.long = long;
    },
    setAgreedTerms(state, value) {
      state.agreedTerms = value;
    },
    setSilmeeByWeek(state, { silmeeByWeek }) {
      state.silmeeByWeek = silmeeByWeek;
    },
    setWalkxByWeek(state, { walkxByWeek }) {
      state.walkxByWeek = walkxByWeek;
    },
    setResponseDataForMonthMode(state, { responseDataForMonthMode }) {
      state.responseDataForMonthMode = responseDataForMonthMode;
    },
    setResponseDataForGroupMode(state, { responseDataForGroupMode }) {
      state.responseDataForGroupMode = responseDataForGroupMode;
    },
  },
  actions: {},
  modules: {
    [STATISTIC_NAMESPACE]: statistic,
    [FEEDBACK_NAMESPACE]: feedback,
  },
});
